// extracted by mini-css-extract-plugin
module.exports = {"maxZIndex":"2147483647","checkableOptionItemOffset":"68px","maxImageQuestionItemCount":"52","matrixCellWidth":"46px","maxMatrixCellWidth":"70px","tool":"RBbTeNKB-4L8ONIa15qPG"};